import Image from 'next/legacy/image';
import Link from 'next/link';
import { BodyRegular, H2, H4 } from '@components/atoms/typography';

const ToolsShowcase = ({
  imagePath,
  toolsData,
  header = 'Let our tools do the hard work'
}) => (
  <div className="px-5 my-5 md:my-10 flex flex-col lg:flex-row space-x-3 justify-evenly space-y-5">
    <div className="flex justify-center items-center">
      <Image
        src={imagePath}
        alt="Description of tools that are available on Fantasy Football Hub's website"
        height={550}
        width={550}
      />
    </div>
    <div className="flex flex-col space-y-3 justify-center max-w-[490px]">
      <H2>{header}</H2>
      {toolsData.map((tool, index) => (
        <div
          className="flex flex-col space-y-3 justify-center max-w-[490px]"
          key={index}
        >
          <Link href={tool.link}>
            <H4 className="cursor-pointer hover:text-primary-600 hover:underline">
              {tool.header}
            </H4>
          </Link>
          <BodyRegular>{tool.description}</BodyRegular>
        </div>
      ))}
    </div>
  </div>
);

export default ToolsShowcase;
